module.exports = __webpack_public_path__ + "media/images/posts/wedding-food-95284a3b68db84810a25d91d10f51057.jpg";